import { useRef, useState } from "react";
import { Eye, ChevronDown, Check } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import { useClickOutside } from "../../hooks";
import { isAdmin, ROLES } from "../../constants/roles";
import type { RoleName } from "../../constants/roles";

const OPTIONS: { value: RoleName | null; label: string }[] = [
  { value: null, label: "Full access" },
  { value: ROLES.ANALYST, label: "Analyst" },
  { value: ROLES.VIEWER, label: "Viewer" },
];

export default function ViewAsControl() {
  const { realUser, viewAsRole, setViewAsRole } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  useClickOutside(ref, () => setOpen(false), open);

  if (!isAdmin(realUser)) return null;

  const current = OPTIONS.find((option) => option.value === viewAsRole) ?? OPTIONS[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((isOpen) => !isOpen)}
        title="Preview the app as a lower role"
        className={`flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-xs font-medium transition-colors ${
          viewAsRole
            ? "border-amber-300 bg-amber-50 text-amber-700"
            : "border-gray-200 text-gray-600 hover:bg-gray-50"
        }`}
      >
        <Eye size={13} />
        <span className="hidden sm:inline">View as: {current.label}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div className="absolute right-0 top-full z-30 mt-1 w-40 rounded-lg border border-gray-200 bg-white py-1 shadow-md">
          {OPTIONS.map((option) => (
            <button
              key={option.label}
              onClick={() => { setViewAsRole(option.value); setOpen(false); }}
              className="flex w-full items-center justify-between px-3 py-2 text-left text-xs text-gray-700 hover:bg-gray-50"
            >
              {option.label}
              {current.value === option.value && <Check size={13} className="text-[#1D345F]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
